export const fallbackGallery = [
  {
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/kalas-pink-650x867.jpg",
    title: "Kalas Egetræslagret Gin",
    subtitle: "Matured in French Oak Casks",
    category: "Signature Gin"
  },
  {
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/img-0139-650x867.jpg",
    title: "The Perfect Serve",
    subtitle: "Håndplukkede urter og ren krystalklar balance",
    category: "Experience"
  },
  {
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/img-5469-800x1200.jpeg",
    title: "Kalas Slåen Likør",
    subtitle: "Vilde slåenbær og langsom maseration",
    category: "Liqueur"
  },
  {
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/kalas-rabarber-gin-orange-1-650x867.jpg",
    title: "Kalas Rabarber Gin",
    subtitle: "Friske danske rabarber med citrus-undertoner",
    category: "Special Edition"
  },
  {
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/img-5499-800x1200.jpeg",
    title: "Destillation & Detaljer",
    subtitle: "Kompromisløs kvalitet i hver eneste dråbe",
    category: "Craft"
  },
  {
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/img-7021-650x867.jpg",
    title: "Destilleriet på Sydals",
    subtitle: "Holtvej 8 – Hvor naturens ro møder kobberet",
    category: "Heritage"
  },
  {
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/4-650x867.png",
    title: "Kalas Classic Dry Gin",
    subtitle: "Klassisk enebærprofil destilleret til perfektion",
    category: "Classic"
  },
  {
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/2-650x867.png",
    title: "Kalas Hindbær Gin",
    subtitle: "Solmodne bær og botanisk elegance",
    category: "Botanical"
  }
];

export const fallbackAwards = [
  {
    year: "2023",
    title: "Best Danish Matured Gin",
    award_name: "World Gin Awards",
    medal: "Gold Winner",
    product: "Kalas Egetræslagret Gin"
  },
  {
    year: "2022",
    title: "Best Spirits in Competition",
    award_name: "Frankfurt International Trophy",
    medal: "Grand Gold",
    product: "Kalas Prisvindende Gin"
  },
  {
    year: "2022",
    title: "Exceptional Nordic Craft Spirits",
    award_name: "Nordic Spirits Awards",
    medal: "Gold Medal",
    product: "Kalas Slåen Likør"
  },
  {
    year: "2021",
    title: "Danish Craft Distillery of the Year",
    award_name: "Berlin International Spirits Competition",
    medal: "Double Gold",
    product: "Kalas Rabarber Gin"
  },
  {
    year: "2021",
    title: "Contemporary Gin Trophy Finalist",
    award_name: "International Wine & Spirit Competition",
    medal: "Silver Outstanding",
    product: "Kalas Hindbær Gin"
  }
];

export const mediaLogos = [
  {
    name: "Gastromand",
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/gastromand-logo-300x98.png"
  },
  {
    name: "Euroman",
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/euroman-logo-300x98.png"
  },
  {
    name: "JydskeVestkysten",
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/jv-logo-300x98.png"
  },
  {
    name: "En Verden Af Gin",
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/enverdenafgin-300x98.png"
  },
  {
    name: "TV Syd",
    url: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/tvsyd-logo-300x98.png"
  }
];

export const storytellingChapters = [
  {
    number: "01",
    type: "video",
    src: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/rundvisning-video.mp4",
    tagline: "Rundvisning & Destilleriet",
    title: "Indenfor i Kobberets Hjerte",
    subtitle: "En guidet rejse i destilleriets maskinrum",
    body: "Træd direkte ind i vores arbejdende destilleri på Sydals. Her møder du de skinnende kobberkedler, duften af friskdestillerede urter og den passion, der driver hver enkelt dråbe frem fra råvare til færdig flaske.",
    accent: "Sydals · Holtvej 8",
    duration: "Brand Tour"
  },
  {
    number: "02",
    type: "video",
    src: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/story-some.mp4",
    tagline: "Hverdagen & Atmosfæren",
    title: "Livet og Stemningen bag KALAS",
    subtitle: "Nærvær, natur og uformel hygge",
    body: "KALAS er ikke blot et destilleri – det er et levende mødested. Glimt fra en hverdag præget af fællesskab, kystnatur og en kompromisløs dedikation til det gode, nære håndværk under åben himmel.",
    accent: "Fællesskab & Natur",
    duration: "Story / SoMe"
  },
  {
    number: "03",
    type: "video",
    src: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/oplevelsesoekonomi-smagning.mp4",
    tagline: "Smagninger & Oplevelser",
    title: "Sanselige Smagninger ved Kysten",
    subtitle: "Oplevelser skabt til at deles",
    body: "Gennem guidede smagninger inviterer vi gæster ind til at udforske nuancerne i vores gin, likører og fadlagrede specialiteter. Hør historierne, smag råvarerne og mærk forskellen i det ægte håndværk.",
    accent: "Masterclass & Smagning",
    duration: "Oplevelser"
  },
  {
    number: "04",
    type: "video",
    src: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/engelsk-voiceover.mp4",
    tagline: "Den Nordiske Vision",
    title: "The Spirit of Als – Vores Fortælling",
    subtitle: "International klasse med lokale rødder",
    body: "Historien om KALAS Distillery fortalt med internationalt udsyn. Fra de vilde kyster på Als til anerkendte spirituspriser – en kompromisløs hyldest til renhed, tålmodighed og karakter.",
    accent: "Nordic Spirit · World Class",
    duration: "Voiceover Feature"
  },
  {
    number: "05",
    type: "image",
    src: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/img-4202.jpg",
    tagline: "Håndplukkede Råvarer",
    title: "Botanicals & Naturens Skatkammer",
    subtitle: "Friske urter, enebær og bær fra Als",
    body: "Hver eneste opskrift starter i den vilde natur omkring os på Sydals. Vi udvælger og håndsorterer urter, vilde bær og botanicals for at skabe balancerede, aromatiske smagsoplevelser med dybde og kant.",
    accent: "Lokalt sanket på Sydals",
    duration: "Fotografi"
  },
  {
    number: "06",
    type: "image",
    src: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/billede-5.png",
    tagline: "Destillationskunsten",
    title: "Kobber, Damp & Tålmodighed",
    subtitle: "Traditionelt håndværk i moderne rammer",
    body: "Præcis temperaturstyring og langsom kobberdestillation lader de æteriske olier fra vores botanicals folde sig fuldstændigt ud. Det tager tid, men resultatet er en uforlignelig ren og silkeblød tekstur.",
    accent: "100% Kobberdestillation",
    duration: "Fotografi"
  },
  {
    number: "07",
    type: "image",
    src: "https://assets.auxodev.dk/assets/c8fc1da7-d576-4041-8666-592c544bae24/dsc02185.jpg",
    tagline: "Den Færdige Flaske",
    title: "Karakter på Flaske & Hylder",
    subtitle: "Håndaftappet med kærlighed til detaljen",
    body: "Fra kobberkedlen til den forseglede flaske. Hver batch nummereres og afsluttes i hånden på Sydals – klar til at blive nydt ren, over is eller i selskab med dem, du holder af.",
    accent: "Handcrafted & Numbered",
    duration: "Fotografi"
  }
];
